"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Image = _interopRequireDefault(require("../../Image"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _utils = require("./../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
// interface scene_inter {
//   source?:string,    //默认图
//   filedVideoBg?:string,  //视频播放初始化背景图
//   filedVideoList?:string, //视频地址
//   logoImg?:string,  //文章logo
//   title?:string,   //文章标题
//   content?:string,  //内容
// }
// type scene_obj = {
//   flexTitle?:string,  //标题
//   moreHandle?:Function,  //移动端加载更多回调
//   moreText?:string,   //加载更多
//   lazyText?:string,  //加载更多loading
//   configuration?:Array<scene_inter>
// }
function PictureComponent(props) {
  var imageSrc = props.imageSrc;
  var _a = (0, _utils.fomateFileData)(imageSrc),
    url = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)({}),
    styles = _c[0],
    setStyls = _c[1];
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      var collectStyles = {};
      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({
      maxWidth: '160px',
      maxHeight: '54px',
      width: '10px'
    }, styles),
    src: url,
    alt: alt
  });
}
var Article = function Article(props) {
  var className = props.className,
    href = props.href,
    onCallbackHandle = props.onCallbackHandle,
    logoImg = props.logoImg,
    record = props.record,
    title = props.title,
    article = props.article,
    hrefText = props.hrefText,
    index = props.index;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article', className),
    "report-event": "click_sceneChange_card",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || '',
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-default-article-container__section'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-article-container__section__div',
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, logoImg && ( /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '160px',
      height: '54px',
      display: 'flex',
      // justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
    imageSrc: logoImg
  }))), title && /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'title-class wordBreak lineBreak'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'div-content',
    style: {
      // listStyle: 'inside',
      // textIndent: "-24px",
      // paddingLeft: "24px"/
    },
    dangerouslySetInnerHTML: {
      __html: article
    }
  }), href && ( /*#__PURE__*/_react["default"].createElement("a", {
    className: 'flex-default-article_a',
    href: href,
    "report-event": "click_sceneChange_href",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || ''
  }, hrefText || "Learn more ", " >"))))));
};
var SceneChangeComponent = function SceneChangeComponent(props) {
  var banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    imageSrc = props.imageSrc,
    flexTitle = props.flexTitle,
    style = props.style,
    _a = props.imageLocation,
    imageLocation = _a === void 0 ? false : _a,
    configuration = props.configuration,
    moreHandle = props.moreHandle,
    className = props.className,
    onClick = props.onClick,
    moreText = props.moreText,
    lazyText = props.lazyText,
    _b = props.lazyStatus,
    lazyStatus = _b === void 0 ? true : _b,
    restProps = __rest(props, ["banner", "sharp", "radius", "imageSrc", "flexTitle", "style", "imageLocation", "configuration", "moreHandle", "className", "onClick", "moreText", "lazyText", "lazyStatus"]);
  var scroll_ref = (0, _react.useRef)(null);
  var scroll_left_ref = (0, _react.useRef)(null);
  var scroll_right_ref = (0, _react.useRef)(null);
  var _c = (0, _react.useState)(0),
    move_scroll_val = _c[0],
    setmove_scroll_val = _c[1];
  var ball = (0, _react.useState)({
    x: 0,
    y: 0,
    target_x: 0,
    target_y: 0,
    cache: {
      x: 0,
      y: 0
    }
  })[0];
  var dataList = configuration || [];
  var _d = (0, _react.useState)([]),
    list = _d[0],
    setList = _d[1];
  var _e = (0, _react.useState)(false),
    loading = _e[0],
    setLoading = _e[1];
  var _f = (0, _react.useState)(0),
    current = _f[0],
    setCurrent = _f[1];
  var dataLen = dataList ? dataList.length : 0;
  var len3 = Math.floor(dataLen / 3);
  var visibleible = function visibleible(val) {
    if (!scroll_right_ref.current) return;
    scroll_right_ref.current.style.visibility = val || 'visible';
  };
  var visibleibleLeft = function visibleibleLeft(val) {
    if (!scroll_left_ref.current) return;
    scroll_left_ref.current.style.visibility = val || 'visible';
  };
  var displayible = function displayible() {
    if (!scroll_ref.current) return;
    if (dataLen > 3) {
      visibleible();
    }
  };
  var tx_move = function tx_move() {
    var easing = 0.09;
    ball.x += (ball.target_x - ball.x) * easing;
    if (!scroll_ref.current) return;
    scroll_ref.current.style.transform = "translate(" + -Math.floor(ball.x) + "px,0px)";
    if (Math.ceil(ball.x) !== ball.target_x && Math.floor(ball.x) !== ball.target_x) {
      requestAnimationFrame(tx_move);
    }
    if (ball.target_x >= scroll_ref.current.scrollWidth - move_scroll_val) {
      visibleible('hidden');
    } else {
      visibleible('visible');
    }
    if (ball.target_x >= move_scroll_val - len3 * 48) {
      visibleibleLeft('visible');
    } else {
      visibleibleLeft('hidden');
    }
    // console.log('test');
  };
  var _g = (0, _react.useState)(0),
    childrenWidth = _g[0],
    setChildren = _g[1];
  var computeWidth = function computeWidth(w) {
    var c_w = (w - 24) / 3;
    var getClientWidth = document.querySelectorAll('.scene-flex-default-area-card-revert-container-member');
    if (getClientWidth) {
      getClientWidth.forEach(function (item, _index) {
        // @ts-ignore
        item.style.width = c_w + "px";
        // @ts-ignore
        item.style.minWidth = 'initial';
      });
    }
    var computeWidthValue = 0;
    if (getClientWidth) {
      computeWidthValue = c_w * 3;
    }
    setChildren(computeWidthValue);
  };
  (0, _react.useEffect)(function () {
    displayible();
    if (!scroll_ref.current) return;
    var getClientWidth = document.querySelector('.flex-scene-default-a-container__expand');
    var _move_scroll_val = 0;
    if (getClientWidth) {
      _move_scroll_val = getClientWidth.clientWidth;
      setmove_scroll_val(_move_scroll_val);
    }
    (0, _utils.windowAddEventListener)(function (status) {
      if (status) {
        computeWidth(_move_scroll_val);
      }
    });
    var changeVal = Math.ceil(scroll_ref.current.scrollWidth / _move_scroll_val);
    setList(__spreadArrays(new Array(changeVal).fill({
      checked: false
    }) || []));
  }, [move_scroll_val, childrenWidth]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-scene-default-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-scene-default-a-container__expand',
    style: (dataList ? dataList.length > 3 : 0) ? {} : {
      maxWidth: '1440px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-scene-default-container-children-a',
    style: (dataList ? dataList.length > 3 : 0) ? {} : {
      maxWidth: '1440px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'extent-title'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  })), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('scene-flex-default-area-card-revert'),
    ref: scroll_ref
  }, restProps), dataList.map(function (item, index) {
    var source = item.source,
      content = item.content,
      logoImg = item.logoImg,
      title = item.title,
      href = item.href,
      hrefText = item.hrefText,
      supplement = item.supplement,
      filedVideoList = item.filedVideoList,
      filedVideoBg = item.filedVideoBg;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('scene-flex-default-area-card-revert-container-member scene-flex-default-area-card-revert-container-member-col3', {
        'scene-flex-default-area-card-revert-container-member-col3__none': supplement
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'new-scene-container'
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      className: 'scene-change-svg',
      width: '564',
      height: '317',
      source: source,
      filedVideoList: filedVideoList,
      filedVideoBg: filedVideoBg,
      style: {
        height: 'auto',
        backgroundRepeat: '',
        // borderRadius: contentMaxHeight ? "inherit" : "7px",
        borderTopLeftRadius: '7px',
        borderTopRightRadius: '7px',
        borderBottomLeftRadius: '7px',
        borderBottomRightRadius: '7px'
      },
      record: item || {}
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-area-card-article-col3'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-text-article-container'),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-img-container-default-article scene-img-container-default-article__article'
    }, /*#__PURE__*/_react["default"].createElement(Article, {
      record: item || {},
      article: content,
      logoImg: logoImg,
      title: title,
      href: href,
      hrefText: hrefText,
      index: index
    }))))));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: scroll_left_ref,
    className: 'scroll_left_class-a',
    onClick: function onClick() {
      // @ts-ignore
      if (ball.target_x > 0) {
        var val = childrenWidth;
        ball.target_x -= val;
        tx_move();
        setCurrent(current - 1);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29297 9.70712L7.70718 8.29291L12.0001 12.5858L16.293 8.29291L17.7072 9.70712L12.0001 15.4142L6.29297 9.70712Z",
    fill: "black"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: scroll_right_ref,
    className: 'scroll_right_class-a',
    onClick: function onClick() {
      // @ts-ignore
      // if (ball.target_x < scroll_ref.current.scrollWidth - scroll_ref.current.clientWidth) {
      var val = childrenWidth;
      ball.target_x += val;
      tx_move();
      setCurrent(current + 1);
      // }
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29297 9.70712L7.70718 8.29291L12.0001 12.5858L16.293 8.29291L17.7072 9.70712L12.0001 15.4142L6.29297 9.70712Z",
    fill: "black"
  }))), configuration && configuration.length > 3 ? ( /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'scroll_ul'
  }, list.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: (0, _classnames["default"])('', {
        'current-active': current === index
      }),
      onClick: function onClick() {
        if (current === index) return;
        // @ts-ignore
        // console.log(scroll_ref.current.scrollWidth, ball.target_x, index);
        var val = childrenWidth;
        ball.target_x = val * index;
        setCurrent(index);
        tx_move();
      },
      key: index
    });
  }))) : null, lazyStatus ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "move-client-case-class"
  }, loading ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'move-client-case-class__font-size'
  }, lazyText || '加载中...')) : ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      setLoading(true);
      setTimeout(function () {
        setLoading(false);
        moreHandle && moreHandle();
      }, 300);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, moreText || '更多案例'), /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-arrow"
  })), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 6.29297L8.58594 7.70718L12.8788 12.0001L8.58594 16.293L10.0002 17.7072L15.7073 12.0001L10.0002 6.29297Z",
    fill: "black"
  })))))) : null));
};
SceneChangeComponent.displayName = 'TCISceneChangeComponent';
var _default = exports["default"] = SceneChangeComponent;